import React, { Component } from 'react';
import Directory from './Directory';

export default class DirectoryContainer extends Component {

    calculateColumnSize(itemIndex, itemsPerRow = 3, gridSize = 12) {
        const itemsCount = this.props.items.length;

        const modulo = itemsCount % itemsPerRow;

        const isOnSuitableRow = itemIndex < itemsCount - modulo;

        return isOnSuitableRow ?
            gridSize / itemsPerRow :
            gridSize / modulo;
    }

    render() {
        return (

            <div className="card-deck">
                {this.props.items.map((v, i) => {
                return <Directory {...v} columnWidth={this.calculateColumnSize(i)} key={i} />
                })}
            </div>
        );
    }
    
}


// WEBPACK FOOTER //
// ./web/src/components/common/directory/DirectoryContainer.jsx